import { ProfileCircleSvg, ShieldTickSvg, SmsSvg } from "svg/icons";
import { useUser } from "context/AuthContext";

export default function UserInfo() {

   const user = useUser();

   const info = [
      { label: "Imie i nazwisko", value: user?.name, Icon: <ProfileCircleSvg/> },
      { label: "Rola", value: user?.role?.label, Icon: <ShieldTickSvg/> },
      { label: "Adres e-mail", value: user?.email, Icon: <SmsSvg/> },
   ]

   return (
      <div className="profile-settings-info">

         <div>
            <h3> Twoje dane </h3>
         </div>
         
         { info.map(({ label, value, Icon }) => {
            return (
               <div key={ label }>
                  <div> 
                     { Icon } <strong> { label } </strong>
                  </div>
                  <span> { value } </span>
               </div>
            )
         })}
      </div>
   )
}